import { supabase } from '@/lib/supabase';
import { ShopSettings, Profile } from '@/types/models';

export async function fetchShopSettings(): Promise<ShopSettings> {
  const { data, error } = await supabase
    .from('shop_settings')
    .select('*')
    .eq('id', true)
    .single();

  if (error) throw error;
  return data as ShopSettings;
}

export async function updateShopSettings(
  payload: Partial<Omit<ShopSettings, 'id' | 'updated_at'>>
): Promise<ShopSettings> {
  const { data, error } = await supabase
    .from('shop_settings')
    .update({
      ...payload,
      updated_at: new Date().toISOString(),
    })
    .eq('id', true)
    .select()
    .single();

  if (error) throw error;
  return data as ShopSettings;
}

export async function fetchUsersList(): Promise<Profile[]> {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .order('full_name');

  if (error) throw error;
  return (data ?? []) as Profile[];
}

export async function updateUserRole(profileId: string, role: 'owner' | 'manager' | 'staff'): Promise<Profile> {
  const { data, error } = await supabase
    .from('profiles')
    .update({ role })
    .eq('id', profileId)
    .select()
    .single();

  if (error) throw error;
  return data as Profile;
}

export async function updateUserActiveState(profileId: string, isActive: boolean): Promise<Profile> {
  const { data, error } = await supabase
    .from('profiles')
    .update({ is_active: isActive })
    .eq('id', profileId)
    .select()
    .single();

  if (error) throw error;
  return data as Profile;
}
